module.exports = __webpack_public_path__ + "assets/img/dzh-21.50a14cf5.jpg";